import axiosInstance from '../../services/axios';
import { applyFilters, getAPIEndpoint } from '../../helpers'


export default {
    namespaced: true,
    state: {
        dashboard: {},
        questionManager: []
    },
    getters: {




    },
    actions: {

        getDashboard({ state, commit }) {

            const url = `${getAPIEndpoint()}/dashboard`

            return axiosInstance.get(url).then(res => {

                const dashboardData = res.data.data;


                commit('setDashboard', dashboardData);
                // const response = res.data.data.data

                // commit('loadProducts', productArray)


            })


        },
        // getQuestionManagers({ state, commit }) {

        //     const url = `${getAPIEndpoint()}/dashboard/questionManagers`

        //     return axiosInstance.get(url).then(res => {

        //         console.log(res.data.data);

        //         const questionManagerData = res.data.data;


        //         commit('setManagers', questionManagerData);
        //         // const response = res.data.data.data

        //         // commit('loadProducts', productArray)


        //     })


        // }




    },
    mutations: {
        setDashboard(state, dashboardData) {
            state.dashboard = dashboardData;
        },
        setManagers(state, managerData) {
            state.questionManager = managerData;
        }

    }
}